import { useState } from "react";

/**
 * PasswordResetPage
 * Props:
 *   onSubmit(email: string)
 *   onBackToLogin()
 *   sent — bool, show confirmation state instead of the form
 */
export default function PasswordResetPage({ onSubmit, onBackToLogin, sent = false }) {
  const [email, setEmail] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit?.(email);
  }

  return (
    <div style={{ maxWidth: 380, margin: "0 auto", background: "var(--surface-1)", borderRadius: "var(--radius-lg)", padding: "2rem" }}>
      {sent ? (
        <>
          <p style={{ fontSize: "var(--text-xl)", fontWeight: 500, margin: "0 0 4px" }}>Check your email</p>
          <p style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)", margin: "0 0 20px" }}>
            If an account exists for {email || "that address"}, a reset link is on its way.
          </p>
        </>
      ) : (
        <>
          <p style={{ fontSize: "var(--text-xl)", fontWeight: 500, margin: "0 0 4px" }}>Reset your password</p>
          <p style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)", margin: "0 0 20px" }}>
            We'll email you a link to set a new one.
          </p>
          <form onSubmit={handleSubmit}>
            <label style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)", display: "block", marginBottom: 4 }}>Email</label>
            <input
              className="ical-input"
              type="email"
              required
              placeholder="name@company.com"
              style={{ width: "100%", marginBottom: 20 }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="ical-btn ical-btn-primary" style={{ width: "100%", marginBottom: 12 }}>
              Send reset link
            </button>
          </form>
        </>
      )}
      <p style={{ fontSize: "var(--text-xs)", color: "var(--text-muted)", textAlign: "center", margin: 0 }}>
        <button type="button" onClick={onBackToLogin} style={{ color: "var(--text-accent)", background: "none", border: "none", cursor: "pointer", padding: 0, fontSize: "inherit" }}>
          Back to log in
        </button>
      </p>
    </div>
  );
}
